import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordRequirementsValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value?.trim();
    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialCharacter = /[~`! @#$%^&*()-_+={}[]|\;:"<>,.\/?]/.test(
      value
    );
    const hasMinLength = value.length >= 8;
    const hasLowerCase = /[a-z]/.test(value);

    const isValid =
      hasUpperCase &&
      hasNumber &&
      hasSpecialCharacter &&
      hasMinLength &&
      hasLowerCase;

    const passwordRequirements: { [key: string]: boolean } = {};
    if (!hasUpperCase) {
      passwordRequirements['missingUpperCase'] = true;
    }
    if (!hasNumber) {
      passwordRequirements['missingNumber'] = true;
    }
    if (!hasSpecialCharacter) {
      passwordRequirements['missingSpecialCharacter'] = true;
    }
    if (!hasMinLength) {
      passwordRequirements['minLength'] = true;
    }
    if (!hasLowerCase) {
      passwordRequirements['missingLowerCase'] = true;
    }

    return isValid ? null : passwordRequirements;
  };
}
